module.exports = "/assets/b3cab59032d0c713cc31fe8b50e36a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RJ.png
// module id = 1789
// module chunks = 0